/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_Legal_ProcessInputs */

const en_cases_filter_legal_process = /** @type {(inputs: Cases_Filter_Legal_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Process`)
};

const pt_br2_cases_filter_legal_process = /** @type {(inputs: Cases_Filter_Legal_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo judicial`)
};

/**
* | output |
* | --- |
* | "Legal Process" |
*
* @param {Cases_Filter_Legal_ProcessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_legal_process = /** @type {((inputs?: Cases_Filter_Legal_ProcessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_Legal_ProcessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_legal_process(inputs)
	return pt_br2_cases_filter_legal_process(inputs)
});